import script from "./UiKitIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiKitIcon.vue?vue&type=script&setup=true&lang=ts"

import "./UiKitIcon.vue?vue&type=style&index=0&id=3ec78678&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec78678"]])

export default __exports__